@if (field().enabled()) {
  <div class="field-container"
       [class.invalid]="field().ngControl?.invalid"
       *transloco="let t">
    <label>
      @if (field().label()) {
        <span class="label">{{ field().label() }}</span>
      }
      @if (field()?.optional()) {
        <span class="optional-label">(optionnel)</span>
      }
      @if(field()?.description()) {
        <p class="text-muted">
          {{ field()?.description() }}
          @if (showHintToggle()) {
            <a class="hint-toggle" (click)="toggleShowHint()">
              {{ hintToggleLabel() }}
            </a>
          }
        </p>
      }
      @if(showHint()) {
        <p class="text-muted">
          {{ field()?.hint() }}
        </p>
      }
      <div class="mt-1 mb-3">
        <ng-content></ng-content>
        @if (hasErrors()) {
          <div class="invalid-feedback">
            @for (error of errors(); track error.key;) {
              <p>{{ t('form.error.' + error.key) }}</p>
            }
          </div>
        }
      </div>
    </label>
  </div>
<!--  <div *transloco="let t" class="field-wrapper mt-2" [class.invalid]="field()?.typedControl().invalid">-->
<!--    -->

<!--    <ng-content></ng-content>-->
<!--    -->
<!--    @if (errors().length > 0) {-->
<!--      <div class="invalid-feedback">-->
<!--        @for (error of field()?.errors(); track error.key; let isLast = $last) {-->
<!--          <ng-container>{{ t('form.error.' + error.key) }}<br *ngIf="!isLast"/></ng-container>-->
<!--        }-->
<!--      </div>-->
<!--    }-->
<!--  </div>-->
}


